import React, { useCallback } from "react";
import {
  Grid,
  Button,
  TextField,
  InputAdornment
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  Search
} from "@mui/icons-material";
import {useSelector} from "react-redux";
import {getImage} from "../../../../../utils/image";
import clsx from "clsx";
import getTrans from "../../../../../languages/getTrans";

const FilterSection = ({ groups, countryGroup, onChangeCountry, onChangeGroup }) => {
  const classes = useStyles();
  const country = useSelector((state) => state.payflow.selectCountry);

  const handleCountryClick = useCallback(() => {
    onChangeCountry(null);
  }, [onChangeCountry]);

  const handleGroupClick = useCallback((slug) => {
    onChangeGroup(slug);
  }, [onChangeGroup]);

  return (
    <div className={classes.root}>
      <div className={classes.selectCountry}>
        <div>
          {getTrans('filterSection.Recommended payment methods for')}
        </div>
        <div className="--current" onClick={handleCountryClick}>
          <div>{country?.name}</div>
          <div className="--icon">
            <img src={getImage(country.icon_id)}/>
          </div>
        </div>
      </div>

      <div className={classes.groups}>
        <Grid container spacing={1}>
          <Grid item>
            <Button
              onClick={() => handleGroupClick(null)}
              className={clsx({[classes.groupItem]: true, '--selected': Boolean(!countryGroup)})}
            >{getTrans('filterSection.All')}</Button>
          </Grid>
          {groups.map((item) => (
            <Grid key={`group-${ item.paymentMethodId || item.slug }`} item>
              <Button
                className={clsx({
                  [classes.groupItem]: true,
                  '--selected': Boolean(countryGroup === item.slug)
                })}
                onClick={() => handleGroupClick(item.slug)}
              >{ item?.label || item?.name }</Button>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  )
}
const useStyles = makeStyles((theme) => ({
  root: {},
  selectCountry: {
    marginTop: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",

    fontSize: 16,
    color: "white",
    fontWeight: "500",
    lineHeight: "20px",

    "& .--current": {
      gap: "8px",
      display: "flex",
      color: "#FB7800",
      marginTop: "6px",
      fontWeight: "600",
      padding: "4px 10px",
      borderRadius: "8px",
      alignItems: "center",
      boxSizing: "border-box",
      backgroundColor: "#FFFFFF0D",
      border: "1px solid #FFFFFF1A",
    },
    "& .--current .--icon": {
      width: 22,
      height: 16,
      overflow: "hidden",
      borderRadius: "4px",
      position: "relative",
      border: "1px solid white",

      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "50% 50%",
      }
    },
  },

  groups: {
    marginTop: "12px"
  },
  groupItem: {
    height: 35,
    padding: "0 10px",
    minWidth: "initial",
    minHeight: "initial",
    background: "#FFFFFF1A!important",
    border: "1px solid #FFFFFF1A!important",

    fontSize: "15px",
    lineHeight: "18px",
    color: "#F5F5F5!important",

    "&.--selected": {
      borderColor: "#FB7800!important",
      backgroundColor: "#FB7800!important",
    }
  },
}));
export default FilterSection
